/*
 * Spinder Design — Montage-instructies modal
 * ------------------------------------------
 * Opent een ingesloten PDF-viewer (iframe) bij klik op de knop.
 * Event-gedelegeerd op document, zodat het ook werkt nadat Dawn de knop-HTML
 * vervangt bij een variant-/kleurwissel. De iframe laadt pas bij openen (lazy)
 * en wordt bij sluiten geleegd zodat de PDF stopt met laden.
 */
(function () {
  'use strict';

  function openModal(root) {
    var modal = root.querySelector('[data-manual-modal]');
    var frame = root.querySelector('[data-manual-frame]');
    if (!modal || !frame) return;
    var pdf = frame.getAttribute('data-pdf');
    // Security: alleen https-URL's in de iframe (weert javascript:/data:-URL's).
    if (pdf && !/^https:\/\//i.test(pdf)) pdf = null;
    if (pdf && !frame.querySelector('iframe')) {
      var ifr = document.createElement('iframe');
      ifr.src = pdf;
      ifr.title = 'Montage-instructies';
      frame.appendChild(ifr);
    }
    modal.hidden = false;
    document.documentElement.classList.add('spd-manual-open');
    var closeBtn = modal.querySelector('[data-manual-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('spd-manual-open');
    var frame = modal.querySelector('[data-manual-frame]');
    if (frame) frame.innerHTML = ''; // laden stoppen + geheugen vrij
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest && e.target.closest('[data-manual-open]');
    if (openBtn) {
      var root = openBtn.closest('[data-spinder-manual]');
      if (root) { e.preventDefault(); openModal(root); }
      return;
    }
    var closeBtn = e.target.closest && e.target.closest('[data-manual-close]');
    if (closeBtn) { closeModal(closeBtn.closest('[data-manual-modal]')); return; }
    // klik op de donkere achtergrond (het modal-element zelf) sluit
    if (e.target.matches && e.target.matches('[data-manual-modal]')) closeModal(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-manual-modal]:not([hidden])');
    if (open) closeModal(open);
  });
})();
